/**
 * 活动状态值
 * @see https://yapi.geekbang.org/project/71/interface/api/933
 */
export const activityStatusInfo = {
  '0': 'TOPUBLISH', // 未发布
  '1': 'PUBLISHED', // 已发布
  '2': 'CANCEL', // 已取消
  '4': 'DELETE' // 作废删除
}

/**
 * 当活动已发布，即 activityStatus 为 1，活动的状态值
 * 前端根据活动的开始、结束时间定义
 */
export const activityPublishedStatusInfo = {
  // 未开始 - 报名阶段
  'BOOKING': 'BOOKING',
  // 未开始 - 签到阶段
  'SIGNING': 'SIGNING',
  // 进行中
  'INTERM': 'INTERM',
  // 已结束
  'OUTTERM': 'OUTTERM'
}

/**
 * 用户参与活动状态值
 * @see https://yapi.geekbang.org/project/71/wiki
 */
export const activityUserSignStageInfo = {
  '-10': 'HAS_NO_RIGHT', // 没有权限
  '-2': 'BOOK_FAIL', // 报名失败
  '-1': 'CANCEL', // 已取消报名
  '0': 'NORMAL', // 默认
  '3': 'AUDIT_FAIL', // 审核失败
  '4': 'AUDIT', // 审核中
  '8': 'BACK', // 候补中
  '12': 'TOPAY', // 待缴费
  '16': 'TOSIGN', // 待签到
  '20': 'SUCC' // 完成
}

/**
 * 用户缴费形式
 */
export const payMethod = {
  'TICKET': 'TICKET',
  'MARGIN': 'MARGIN'
}

export const offlinePayInfo = {
  name: '户名：北京极客邦科技有限公司',
  account: '110913419210103',
  bank: '开户行：招商银行股份有限公司北京望京支行',
  company: '公司名称：北京极客邦科技有限公司',
  mark: '备注：企业名称+报名者姓名',
  alipayAccount: '支付宝账号：tgo@geekbang.com'
}

/**
 * 非会员可免门票的参与活动次数上限
 */
export const joinCountForFree = 2

/**
 * 分会ID，正式与测试的映射表，第一个为测试，第二个为正式
 */
export const branchIdMap = {
  beijing: [11, 1],
  chengdu: [27, 6],
  guangzhou: [25, 4],
  hangzhou: [23, 3],
  nanjing: [22, 8],
  shanghai: [21, 2],
  shenzhen: [26, 5],
  suzhou: [28, 12],
  taibei: [19, 10],
  wuhan: [24, 9],
  xiamen: [20, 11],
  silicon: [12, 7],
  singapore: [35, 19]
}
